var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icons_Idle_08_Deny"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Idle_08_Deny",
    clipPath: "url(#clip-Icons_Idle_08_Deny)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Idle_08_Deny-2",
    "data-name": "Icons_Idle_08_Deny",
    transform: "translate(-11.816 -13.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(11.816 13.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M73.689,489.8a9.912,9.912,0,0,1-7.979-4.18C-11.04,375.816-5.341,226.495,79.768,122.768A298.461,298.461,0,0,1,396.647,25.881a9.5,9.5,0,0,1-5.319,18.238A280.02,280.02,0,0,0,94.586,134.927C14.8,232.194,9.477,371.636,81.667,474.6a9.673,9.673,0,0,1-2.28,13.3A11.306,11.306,0,0,1,73.689,489.8Z",
    transform: "translate(-11.816 -13.285)",
    fill: "#c1c1c1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(219.196 168.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M158.738,498.666a300.447,300.447,0,0,1-85.489-12.538,9.5,9.5,0,0,1,5.319-18.238A279.619,279.619,0,0,0,375.31,377.082a280.767,280.767,0,0,0,31.916-308.9,9.6,9.6,0,0,1,17.1-8.739A299.805,299.805,0,0,1,158.738,498.666Z",
    transform: "translate(-66.396 -54.227)",
    fill: "#c1c1c1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M406.948,433.04c-16.718-25.837-33.816-51.673-49.394-77.89-6.839-11.778-14.058-23.177-20.9-34.955C353,298.537,369.333,276.5,385.671,254.843c43.314-57.752,86.629-115.885,131.843-172.5-28.5-19.377-57.373-38.375-85.869-57.752-4.939-3.42-10.639-6.839-17.1-5.319-5.7,1.52-10.259,6.459-14.058,11.4-45.214,55.473-88.529,118.545-132.6,182.376-1.14-1.52-1.9-3.04-3.04-4.559-15.578-24.317-31.536-48.634-47.494-72.951-7.979-12.158-15.578-24.317-23.557-36.855-3.8-6.079-7.6-12.158-11.4-18.618-2.28-3.8-4.939-12.158-10.259-12.918-4.939-.38-11.4,3.42-15.2,6.079-6.839,4.559-13.3,9.119-19.757,14.058-13.3,9.119-26.6,18.618-39.895,27.736-4.179,3.04-9.119,6.459-9.879,11.778-.76,4.559,1.9,9.119,3.8,13.3,28.116,59.272,64.972,117.025,104.866,174.777-44.834,61.172-91.188,119.3-142.481,167.178-4.559,4.18-9.5,8.359-13.678,13.3-3.42,3.8-11.4,6.839-9.119,12.538a42.753,42.753,0,0,0,4.559,7.979l64.212,59.652c4.559,4.18,9.119,8.739,15.2,10.259a9.355,9.355,0,0,0,4.559.38l2.28-1.14c9.119-5.7,15.958-15.2,23.177-22.8,7.979-8.359,15.578-17.1,22.8-25.837,30.016-35.715,57.373-73.71,86.249-109.806,3.8-4.559,7.219-9.5,11.019-14.058,22.417,30.776,44.834,61.552,66.491,92.328,4.939,6.839,12.918,21.657,23.177,16.338l78.27-33.816c7.6-4.18-3.419-17.478-6.079-22.037C420.626,454.317,413.787,443.678,406.948,433.04Z",
    transform: "translate(52.01 15.726)",
    fill: "#ff6912"
  })))));
};
export default __webpack_public_path__ + "static/media/Icons_Idle_08_Deny.e01b6f81.svg";
export { SvgComponent as ReactComponent };